export default "__VITE_ASSET__0Ftv9Tpv__"